
// 成本核算
import TableList from "@components/templates/tablelist";
import { HttpCostCheckList, HttpCostCheckReDetail } from "@/service/fedex";
import { mapGetters } from "vuex";
import comExcel from '@components/templates/excelalert'
// import mixin from "../mixin";
export default {
    mixins: [TableList],
    components: {
        comExcel
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpCostCheckList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case 'redetail':
                    this.operate = {
                        show: true,
                        alert: "warning",
                        params: { ids: params },
                        title: this.$t('global.common.reprocess',{defaultValue:'重处理'}),
                        // desc: " 删除后不可恢复，是否确认删除？",
                        ajaxRequest: HttpCostCheckReDetail
                    };
                    break
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/costSettlement/export', this.formData, {
                        executor:'request',
                        download:true,
                        method:'get',
                    }).then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    })
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList', 'getCusproductList','getCarrierServiceList', 'getCarrierServiceAllList']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.reprocess',{defaultValue:'重处理'}),
                    operate: "redetail",
                    theme: "primary",
                    batch:true,
                },
                {
                    name: this.$t('fbb.alloment.muti_export',{defaultValue:'批量导出'}),
                    operate: "export",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "Tracking NO",
                    tag: 'vInput',
                    key: 'EQ_trackingNo',
                    show: true,
                },
                {
                    label: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
                    tag: 'vInput',
                    key: 'EQ_invoiceNo',
                    show: true,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.bill.freeze_createdat',{defaultValue:'创建日期'}),
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'BT_createdAt',
                    show: true,
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },
                {
                    label: this.$t('bi.work.task_org_id',{defaultValue:'组织'}),
                    tag: 'vSelect',
                    key: 'EQ_orgId',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.project',{defaultValue:'项目'}),
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'}),
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseCode',
                    options: this.getBillcusWareList.map(item=>{
                        return {
                            value: item.attach.code,
                            label: item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                    // label: "承运商服务",
                    tag: 'Select',
                    key: 'EQ_carrierServiceCode',
                    options: this.getCarrierServiceAllList.map(item=>{
                        return {
                            value: item.attach.carrierServiceCode,
                            label:item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                    tag: 'Select',
                    key: 'EQ_carrierCode',
                    more: true,
                    options: [
                        {value:'FedEx',label:'FedEx'},
                        {value:'UPS',label:'UPS'},
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.status',{defaultValue:'状态'}),
                    tag: 'vSelect',
                    key: 'EQ_status',
                    options: [
                        {value:'SETTLEMENT_SUCCESS', label: this.$t('fbb.fedexcost.account_success',{defaultValue:'核算成功'})},
                        {value:'SETTLEMENT_ERROR', label: this.$t('fbb.fedexcost.account_fail',{defaultValue:'核算失败'})},
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.fedexcost.source_order',{defaultValue:'来源订单'}),
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                },
                {
                    label: this.$t('fbb.fedex.account',{defaultValue:'结算账户'}),
                    tag: 'vInput',
                    key: 'EQ_account',
                },
            ]
        },
        columns() {
            return [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },
            {
                title: 'Tracking NO',
                key: 'trackingNo',
            },
            {
                title: this.$t('fbb.fedexcost.source_order',{defaultValue:'来源订单'}),
                key: 'sourceNo',
            },
            {
                title: this.$t('bi.work.task_org_id',{defaultValue:'组织'}),
                key: 'orgName',
            },
            {
                title: this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'}),
                render: (h,{row}) => {
                    let orgWarehouseCode = row.orgWarehouseCode
                    let orgWarehouse = this.getBillcusWareList.find(item=>{
                        return item.attach.code == orgWarehouseCode
                    })
                    return <div>{orgWarehouse ? orgWarehouse.label : '--'}</div>
                }
            },
            {
                title: this.$t('global.common.project',{defaultValue:'项目'}),
                key: 'lineName',
            },
            {
                title: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                // title: "承运商服务",
                key: 'carrierServiceCode',
            },
            {
                title: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                key: 'carrierCode',
            },
            {
                title: this.$t('fbb.fedex.account',{defaultValue:'结算账户'}),
                key: 'account',
            },
            {
                title: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
                key: 'invoiceNo',
            },
            {
                title: this.$t('global.common.status',{defaultValue:'状态'}),
                render: (h, { row }) => {
                    switch (row.status) {
                        case "SETTLEMENT_SUCCESS": return <div class="color-success">{this.$t('fbb.fedexcost.account_success',{defaultValue:'核算成功'})}</div>; break;
                        case "SETTLEMENT_ERROR": return <div class="color-error">{this.$t('fbb.fedexcost.account_fail',{defaultValue:'核算失败'})}</div>; break;
                    }
                }
            },
            {
                title: this.$t('fbb.costmanage.exception_tip',{defaultValue:'异常说明'}),
                key: 'errorMessage',
            },
            {
                title: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                key: 'createdAt',
            },
            ];
        },

    },

};
